/**
 * Vendas Resource
 * Shows completed sales transactions and pending payments
 * Role-based filtering: admins see all, regular users see only their own
 */

import { VendasPage } from './VendasPage';

export const vendas = {
  list: VendasPage,
};

export default vendas;
